import * as Sentry from '@sentry/react'
import cookie from 'js-cookie'

class SSOManager {
  public ssoLogin = () => {
    const currentPath = window.location.pathname || '/'
    window.location.replace('/sso_login?redirect_url=' + currentPath)
  }

  public ssoLogout = () => {
    Sentry.configureScope(scope => scope.setUser(null))
    window.location.replace('/sso_logout?redirect_url=/')
  }

  public isLogined = () => cookie.get('SESSIONID') !== undefined
}

export default new SSOManager()
